import {
  Link,
  MessageBar,
  MessageBarButton,
  MessageBarType,
} from "@fluentui/react";
import React from "react";
interface IMensajeAlerta {
  mensaje: string;
  onDismiss: () => void;
}
export const MensajeBarAlerta = (props: IMensajeAlerta) => {
  return (
    <div>
      <MessageBar
        messageBarType={MessageBarType.warning}
        isMultiline={false}
        onDismiss={props.onDismiss}
        dismissButtonAriaLabel="Close"
        actions={
          <div>
            <MessageBarButton onClick={props.onDismiss}>
              OK
            </MessageBarButton>
          </div>
        }
      >
        {props.mensaje}
      </MessageBar>
    </div>
  );
};
